import { X, TrendingDown, Ban, Wallet, Building, Coins } from "lucide-react";

const dontDoItems = [
  { icon: TrendingDown, text: "No trading signals or recommendations" },
  { icon: Ban, text: "No profit or income claims" },
  { icon: Wallet, text: "No fund or account management" },
  { icon: Building, text: "No brokerage, custody, or execution services" },
  { icon: Coins, text: "No asset solicitation" },
];

const WhatItIsNot = () => {
  return (
    <section data-testid="what-it-is-not-section" className="section-dark">
      <div className="section-pattern" style={{ opacity: 0.1 }}></div>
      <div className="section-glow center"></div>
      
      <div className="container">
        <div className="section-header">
          <div className="section-icon" style={{ background: 'rgba(239, 68, 68, 0.1)' }}>
            <X style={{ color: '#f87171' }} />
          </div>
          <h2 className="section-title">What We Deliberately Do Not Do</h2>
          <div className="section-divider" style={{ background: 'linear-gradient(90deg, transparent 0%, #f87171 50%, transparent 100%)' }}></div>
        </div>
        
        <div className="dont-do-list">
          {dontDoItems.map((item, index) => (
            <div key={index} className="dont-do-item">
              <div className="dont-do-icon">
                <item.icon />
              </div>
              <p className="dont-do-text">{item.text}</p>
            </div>
          ))}
        </div>
        
        <p className="body-text" style={{ textAlign: 'center', marginTop: '48px' }}>
          This separation allows FLEXX Academy to engage publicly and collaboratively without conflict.
        </p>
      </div>
    </section>
  );
};

export default WhatItIsNot;
